<template>
  <section class="py-5">
    <request-materials
      class="mt-4"
      show-type-status-filters
      @requestMaterialsCreated="getRequestMaterials"
      ref="request-materials"
      :customSapStatus="true"
    ></request-materials>
  </section>
</template>

<script>
import RequestMaterials from "../requestMaterials/index.vue";
import { authUsuarioComputed } from "@/state/helpers";
export default {
  components: {
    RequestMaterials,
  },
  data() {
    return {
      project_code: this.$route.query.sap_project,
    };
  },
  methods: {
    async getRequestMaterials() {
      this.$refs["request-materials"].getRequestMaterialsData(1);
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
};
</script>

<style></style>
